<script setup lang="ts">
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue'])

const props = defineProps<{
  modelValue: {
    hours: number | null,
    minutes: number | null,
  }
  month: number
  windowInnerWidth: number
  errors: {
    [key: string]: string[]
  }
}>()

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})
</script>
<template>
  <v-col v-show="windowInnerWidth > 800" cols="2"> </v-col>
  <v-col cols="1">
    <div class="pl-3" style="font-size: 14px">
      {{ props.month }}{{ i18n.global.t('pages.operationOffices.month') }}
    </div>
  </v-col>
  <v-col
    :cols="windowInnerWidth > 800 ? 3 : 5"
    :style="windowInnerWidth > 800 ? '' : 'margin-right: 23px;'"
  >
    <v-text-field
      v-model="modelValue.hours"
      :suffix="i18n.global.t('pages.operationOffices.hours')"
      class="mt-0"
      density="compact"
      :min="0"
      maxlength="4"
      :error-messages="errors[`settings_monthly_report.over_time_thresholds.${props.month}.hours`]"
    />
  </v-col>
  <v-col :cols="windowInnerWidth > 800 ? 3 : 5">
    <v-text-field
      v-model="modelValue.minutes"
      :suffix="i18n.global.t('pages.operationOffices.minutes')"
      class="mt-0"
      density="compact"
      :min="0"
      maxlength="2"
      :error-messages="errors[`settings_monthly_report.over_time_thresholds.${props.month}.minutes`]"
    />
  </v-col>
</template>
